import each from 'lodash/each';

export default function generateTempInspection(id, type) {
  var today = new Date();
  var day = today.getDate();
  if (day < 10) {
    day = '0' + day;
  }
  var month = today.getMonth() + 1;
  if (month < 10) {
    month = '0' + month;
  }
  var pad = Math.floor(Math.random() * 10000);
  let identifier = '' + today.getFullYear() + month + day + pad;
  var idParts = type.split('.');

  var brand = idParts[0];
  brand = brand.charAt(0).toUpperCase() + brand.slice(1);

  const obj = {
    [id]: {
      _id: id,
      identifier: identifier,
      formSchema: type,
      section: brand + '-' + idParts[1].replace('_', ' '),
      status: 'new',
      formData: id,
      formStatus: 'editable',
      imageFileExtension: '.jpg',
      imageOriginalPrefix: 'image-original-',
      imageThumbnailPrefix: 'image-tb-',
      createdBy: {
        firstName: '',
        lastName: '',
      },
      createdAt: today.toISOString(),
      serverTime: today.getTime(),
      costEstimate: {
        // can be null -> no cost estimates at all
        sellerCostEstimate: [], //can be null -> sellers can not leave cost estimates
        departmentCostEstimate: [], //can be null -> department can not leave cost estimates
      },
    },
  };

  // console.log('generateTempInspection obj', obj);
  return obj;
}
const requiredKeys = [
  'goalPrice',
  'logistics',
  // 'marginCurrency',
  'marginPercent',
  'missingEquipment',
  // 'netCredit',
  'offeredPrice',
  'repairEstimate',
];

export function validateCostEstimate(costEstimate) {
  let valid = true;
  if (!costEstimate) return false;
  each(requiredKeys, function(key) {
    if (!costEstimate.hasOwnProperty(key) || costEstimate[key] === null || costEstimate[key] === '') {
      valid = false;
      return false;
    }
  });
  return valid;
}
// deep check if any values found
export function hasCostEstimate(costEstimate) {
  let sellerEstimate = false;
  const sellerCostEstimate = costEstimate.sellerCostEstimate;
  if (sellerCostEstimate) {
    each(requiredKeys, function(key) {
      if (sellerCostEstimate.hasOwnProperty(key) && sellerCostEstimate[key] !== null) {
        sellerEstimate = true;
        // console.log('selleri found', sellerCostEstimate[key]);
      }
    });
  }

  let departmenEstimate = false;
  const departmentCostEstimate = costEstimate.departmentCostEstimate;
  if (departmentCostEstimate) {
    each(requiredKeys, function(key) {
      if (departmentCostEstimate.hasOwnProperty(key) && departmentCostEstimate[key] !== null) {
        departmenEstimate = true;
        // console.log('deppari found', departmentCostEstimate[key]);
      }
    });
  }

  return sellerEstimate || departmenEstimate;
}



// WEBPACK FOOTER //
// ./src/utils/inspection-utils.js